import { api } from '../api';
import { OUTPUT_TEMPLATES_PATH } from '../endpoints';
import { getHeaders } from '../generics/Header';
import { GlobalResponse } from '~/models/Commons ';
import { OutputTemplateItem, OutputTemplateListPayload } from '~/models/outputTemplate/OutputTemplate';

const extendedApiSlice = api.injectEndpoints({
  endpoints: builder => ({
    getOutputTemplates: builder.query<
      GlobalResponse<OutputTemplateListPayload>,
      { page: number; size: number; active?: boolean }
    >({
      query: ({ page, size, active }) => {
        const params = new URLSearchParams({
          page: String(page),
          size: String(size),
        });
        if (active !== undefined) {
          params.append('active', String(active));
        }
        return {
          url: `${OUTPUT_TEMPLATES_PATH}?${params.toString()}`,
          method: 'GET',
          credentials: 'include',
          headers: getHeaders(),
        };
      },
      providesTags: ['OutputTemplates'],
    }),

    getOutputTemplateById: builder.query<
      GlobalResponse<OutputTemplateItem & { body: string }>,
      number
    >({
      query: id => ({
        url: `${OUTPUT_TEMPLATES_PATH}/${id}`,
        method: 'GET',
        credentials: 'include',
        headers: getHeaders(),
      }),
    }),

    createOutputTemplate: builder.mutation<
      GlobalResponse<OutputTemplateItem>,
      { name: string; scriptTypeId: number; cloudProviderId: number; file: File }
    >({
      query: ({ name, scriptTypeId, cloudProviderId, file }) => {
        const formData = new FormData();

        const metadataBlob = new Blob(
          [JSON.stringify({ name, scriptTypeId, cloudProviderId })],
          { type: 'application/json' }
        );
        formData.append('outputTemplate', metadataBlob, 'outputTemplate.json');
        formData.append('file', file);

        return {
          url: OUTPUT_TEMPLATES_PATH,
          method: 'POST',
          body: formData,
          formData: true,
          credentials: 'include',
          headers: getHeaders(),
        };
      },
      invalidatesTags: ['OutputTemplates'],
    }),

    deleteOutputTemplate: builder.mutation<void, number>({
      query: id => ({
        url: `${OUTPUT_TEMPLATES_PATH}/${id}`,
        method: 'DELETE',
        credentials: 'include',
        headers: getHeaders(),
      }),
      invalidatesTags: ['OutputTemplates'],
    }),
  }),
});

export const {
  useGetOutputTemplatesQuery,
  useGetOutputTemplateByIdQuery,
  useLazyGetOutputTemplateByIdQuery,
  useCreateOutputTemplateMutation,
  useDeleteOutputTemplateMutation,
} = extendedApiSlice;
